"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
require("./styles.scss");
const RemoveAllButton = ({ onChange }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: "remove-all", type: "button", onClick: () => {
            onChange([]);
        } }, { children: t("clearAllServices") })));
};
exports.default = RemoveAllButton;
